/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endat1Inputs */

const de__field_endat1 = /** @type {(inputs: _Field_Endat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enddatum`)
};

/**

* @param {_Field_Endat1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_endat1 = /** @type {((inputs?: _Field_Endat1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endat1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_endat1(inputs)
});
export { _field_endat1 as "_field_endAt" }